var CompanySize = {
	"Company size": "حجم الشركة",
	"1-19 employees": "من 1 إلى 19 موظفًا",
	"20-99 employees": "من 20 إلى 99 موظفًا",
	"100-499 employees": "من 100 إلى 499 موظفًا",
	"500-999 employees": "من 500 إلى 999 موظفًا",
	"1,000-9,999 employees": "من 1000 إلى 9999 موظفًا",
	"10,000 employees or more": "10000 موظف أو أكثر"
};

export { CompanySize as default };
